import { Wordmark } from '@/components/nq/Wordmark';

interface BrandMarkProps {
  /** Wordmark font size in px. */
  wordmarkSize?: number;
  /** Tailwind sizing/utility classes for the bull mark. */
  logoClassName?: string;
}

/**
 * Full NovaQuantis lockup — the bull mark + wordmark — matching the WebApp
 * frontends' BrandMark (frontends/app/src/components/BrandMark.tsx).
 */
export function BrandMark({
  wordmarkSize = 22,
  logoClassName = 'h-8 w-8 shrink-0 object-contain',
}: BrandMarkProps) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <img
        src="/assets/logo-bull-trim.png"
        alt=""
        aria-hidden="true"
        className={logoClassName}
        width={32}
        height={32}
      />
      <Wordmark size={wordmarkSize} />
    </span>
  );
}
